.headerContainer {
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0;
  background-color: white;

  .rightSideHeader {
    display: flex;
  }

  .closeButton {
    display: flex;
    justify-content: end;
    width: 100%;
  }

  div {
    height: 40px;
  }

  .disableTile {
    cursor: not-allowed;
  }

  img {
    cursor: pointer;
    padding: 10px 8px;
    height: 20px;
    width: 20px;
    margin: 0 16px;

    &:hover {
      background-color: #f2f2f2;
      border-radius: 4px;
    }
  }
}
